<template>
    <div class="card shadow-sm stat-card h-100">
        <div class="card-body">
            <div class="stat-card-label">{{ label }}</div>

            <div class="stat-card-value-row">
                <div class="stat-card-value">{{ value }}</div>

                <div v-if="trend && trend.label" class="stat-card-trend" :class="trendClass">
                    <font-awesome-icon v-if="trend.direction === 'up'" :icon="['fas', 'arrow-trend-up']"
                        class="trend-icon" />
                    <font-awesome-icon v-else-if="trend.direction === 'down'" :icon="['fas', 'arrow-trend-down']"
                        class="trend-icon" />
                    <font-awesome-icon v-else :icon="['fas', 'minus']" class="trend-icon" />

                    <span class="trend-text">{{ trend.label }}</span>
                </div>
            </div>

            <div class="stat-card-subtitle text-muted small">
                {{ subtitle }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "StatCard",
    props: {
        label: {
            type: String,
            required: true,
        },
        value: {
            type: [String, Number],
            required: true,
        },
        subtitle: {
            type: String,
            default: "",
        },
        trend: {
            type: Object,
            default: null,
        },
    },
    computed: {
        trendClass() {
            if (!this.trend || !this.trend.tone) {
                return "trend-neutral";
            }

            if (this.trend.tone === "positive") {
                return "trend-positive";
            }

            if (this.trend.tone === "negative") {
                return "trend-negative";
            }

            return "trend-neutral";
        },
    },
};
</script>

<style scoped>
.stat-card {
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 16px;
}

.stat-card-label {
    color: #64748b;
    font-size: 0.9rem;
    margin-bottom: 8px;
}

.stat-card-value-row {
    display: flex;
    align-items: baseline;
    gap: 10px;
    margin-bottom: 8px;
    flex-wrap: wrap;
}

.stat-card-value {
    font-size: 2rem;
    line-height: 1;
    font-weight: 700;
    color: #0f172a;
}

.stat-card-trend {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 700;
    line-height: 1;
    transform: translateY(-1px);
}

.trend-icon {
    font-size: 1rem;
}

.trend-text {
    font-size: 0.95rem;
}

.trend-positive {
    color: #16a34a;
}

.trend-negative {
    color: #dc2626;
}

.trend-neutral {
    color: #64748b;
}

.stat-card-subtitle {
    min-height: 20px;
}
</style>